<template>
    <div class="content">
        <h1>BESTELLUNG</h1>
        <div v-if="ShoppingCart && ShoppingCart.Products && ShoppingCart.ProductsValid === true && ShoppingCart.Products.length > 0">
            <p>Hiermit bestelle ich {{ orderProductText }}:</p>
            <div v-for="(item, index) in ShoppingCart.Products" :key="index">
                <p class="item">{{ item.Name }} &nbsp;|&nbsp; {{ item.Price }} €&nbsp;
                    <i
                        class="fas fa-pen change-item"
                        title="Ändern"
                        @click="editItem(item.Id, item.ProductId)">
                    </i>
                </p>
                <div
                    v-for="(data, dataIndex) in item.Data"
                    v-if="data.FirstName"
                    :key="dataIndex"
                    class="item-data">
                    {{ data.FirstName }} {{ data.LastName }}<br>
                    {{ data.PlaceOfBirth }} -
                    {{ data.DayOfBirth }}.{{ data.MonthOfBirth }}.{{ data.YearOfBirth }} -
                    {{ data.HourOfBirth }}:{{ data.MinuteOfBirth }} -
                    {{ data.Gender }}
                </div>
            </div>
            <p class="amount">Gesamtbetrag &nbsp;|&nbsp; {{ amount }} €</p>
            <div id="CustomerData">
                <div class="customer-data">
                    <p class="customer-data-headline">Meine Daten</p>
                    <div class="row">
                        <div class="form-item col-md-6">
                            <select
                                v-model="Customer.Title"
                                :class="[!Customer.Title ? 'form-error' : null, doOrderButtonDisabled ? 'select-disabled' : null]"
                                :disabled="doOrderButtonDisabled"
                                autofocus
                                @change="updateShoppingcartStore()">
                                <option v-for="option in title" :value="option.value" :key="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                            <span class="form-label">&nbsp;Anrede</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-item col-md-6">
                            <input
                                type="text"
                                v-model="Customer.FirstName"
                                :class="!Customer.FirstName ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.FirstName">
                        </div>
                        <div class="form-item-right col-md-6">
                            <input
                                type="text"
                                v-model="Customer.LastName"
                                :class="!Customer.LastName ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.LastName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-item-left col-md-5">
                            <input
                                type="text"
                                v-model="Customer.Street"
                                :class="!Customer.Street ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.Street">
                        </div>
                        <div class="form-item col-md-1">
                            <input
                                type="text"
                                v-model="Customer.StreetNumber"
                                :class="!Customer.StreetNumber ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.StreetNumber">
                        </div>
                        <div class="form-item-right col-md-2">
                            <input
                                type="text"
                                v-model="Customer.ZipCode"
                                :class="!Customer.ZipCode ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.ZipCode">
                        </div>
                        <div class="form-item-right col-md-4">
                            <input
                                type="text"
                                v-model="Customer.City"
                                :class="!Customer.City ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.City">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-item col-md-6">
                            <input
                                type="email"
                                v-model="Customer.Email"
                                :class="!Customer.Email || !validateEmail(Customer.Email) ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.Email">
                        </div>
                        <div class="form-item-right col-md-6">
                            <input
                                type="text"
                                v-model="Customer.Phone"
                                :class="!Customer.Phone ? 'form-error' : null"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.Phone">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-item col-md-12">
                            <textarea
                                type="text"
                                rows="1"
                                v-model="Customer.Remark"
                                :disabled="doOrderButtonDisabled"
                                @input="updateShoppingcartStore()"
                                :placeholder="dataPlaceholder.Remark">
                            </textarea>
                        </div>
                    </div>
                </div>
                <p class="payment-terms">
                    Ich leiste die Zahlung der bestellten Artikel ohne Abzug per Vorkasse und Überweisung innerhalb von 14 Tagen
                    nach Rechnungserhalt an das in der per E-Mail-Anhang erhaltenen Rechnung angegebene Konto.
                </p>
                <div class="agb-row">
                    <div class="agb-input">
                        <input
                            id="Agb"
                            type="checkbox"
                            v-model="Agb"
                            :class="!Agb ? 'form-error' : null"
                            :disabled="doOrderButtonDisabled"
                            @input="updateShoppingcartStore(), emitLogData('checkout', 'agbCheck_' + !Agb)">
                    </div>
                    <div
                        id="AgbText"
                        class="agb-lable"
                        :class="!Agb ? 'agb-lable-error' : null">
                        Mit Abschluss dieser Bestellung bestätige ich, dass ich alle Daten und Angaben auf Richtigkeit
                        überprüft und die <span class="agb-link"><router-link to="/agb">Allgemeinen Geschäftsbedingungen</router-link></span>
                        gelesen und anerkannt habe.
                    </div>
                </div>
                <div class="pos-rel">
                    <div id="SentSuccess" class="sent-success"></div>
                    <div id="SentError" class="sent-error"></div>
                    <button
                        id="DoOrderButton"
                        class="btn btn-success btn-do-order"
                        :disabled="doOrderButtonDisabled"
                        @click="doOrder()">
                        <i v-if="doOrderButtonDisabled" class="fas fa-cog fa-spin"></i>
                        <i v-else class="fas fa-thumbs-up"></i>
                        <span v-if="doOrderButtonDisabled">Bestellung wird gesendet...</span>
                        <span v-else>Jetzt kostenpflichtig bestellen</span>
                    </button>
                    <div id="NotificationSuccess" class="notification-checkout notification-success"></div>
                    <div id="NotificationHint" class="notification-checkout notification-hint"></div>
                    <div id="NotificationErrorCheckout" class="notification-checkout notification-error">
                        Bitte überprüfen Sie Ihre Formulareingaben.
                    </div>
                    <div id="NotificationErrorShoppingcart" class="notification-checkout notification-error">
                        Bitte überprüfen Sie zunächst Ihren <router-link to="/shoppingcart" class="notification-link">Warenkorb</router-link>, bevor Sie hier fortfahren.
                    </div>
                    <div id="NotificationBetaCheckout" class="notification-checkout notification-warning">
                        In dieser Beta-Version ist noch keine Bestellung möglich.<br>
                        Bitte haben Sie noch etwas Geduld.
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="ShoppingCart && ShoppingCart.Products && this.ShoppingCart.Products.length">
                Bitte überprüfen Sie Ihren <router-link to="/shoppingcart"><i class="fas fa-shopping-cart"></i>Warenkorb</router-link>.
            </div>
            <div v-else>
                Es befinden sich noch keine Artikel in Ihrem Warenkorb.
            </div>
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
import axios from 'axios';

let $ = JQuery;

export default {
    name: 'CHECKOUT',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            bookingPossible: true,
            ShoppingCart: null,
            amount: 0,
            orderProductText: '',
            doOrderButtonDisabled: false,
            Customer: {
                Title: null,
                FirstName: '',
                LastName: '',
                Street: '',
                StreetNumber: '',
                ZipCode: '',
                City: '',
                Email: '',
                Remark: ''
            },
            title: [{
                value: null,
                text: '--'
            }, {
                value: 'Frau',
                text: 'Frau'
            }, {
                value: 'Herr',
                text: 'Herr'
            }, {
                value: 'Frau Dr.',
                text: 'Frau Dr.'
            }, {
                value: 'Herr Dr.',
                text: 'Herr Dr.'
            }, {
                value: 'Frau Dr. Dr.',
                text: 'Frau Dr. Dr.'
            }, {
                value: 'Herr Dr. Dr.',
                text: 'Herr Dr. Dr.'
            }, {
                value: 'Frau Prof.',
                text: 'Frau Prof.'
            }, {
                value: 'Herr Prof.',
                text: 'Herr Prof.'
            }, {
                value: 'Frau Prof. Dr.',
                text: 'Frau Prof. Dr.'
            }, {
                value: 'Herr Prof. Dr.',
                text: 'Herr Prof. Dr.'
            }],
            orderDone: false,
            Agb: false
        };
    },
    computed: {
        dataPlaceholder() {
            return {
                FirstName: 'Vorname',
                LastName: 'Nachname',
                Street: 'Straße',
                StreetNumber: 'H.-Nr.',
                ZipCode: 'PLZ',
                City: 'Wohnort',
                Email: 'E-Mail-Adresse',
                Phone: 'Telefonnummer',
                Remark: 'Unverbindliche Anmerkung'
            };
        }
    },
    methods: {
        /**
         * method for getting shoppingcart content
         * ...and setting relevant values
         */
        getShoppingCartContent() {
            let storedShoppingcart = localStorage.getItem('shoppingcart');

            if (storedShoppingcart) {
                this.ShoppingCart = JSON.parse(storedShoppingcart);
            } else {
                this.ShoppingCart = {};
            }

            if (this.ShoppingCart.Products) {
                if (this.ShoppingCart.Products.length > 1) {
                    this.orderProductText = 'folgende Artikel';
                } else {
                    this.orderProductText = 'folgenden Artikel';
                }

                this.ShoppingCart.Products.forEach(item => {
                    this.amount += parseInt(item.Price);
                });
            }

            if (this.ShoppingCart.Customer) {
                this.Customer = this.ShoppingCart.Customer;
            }
        },

        /**
         * method for udating shoppingcart in localStorage
         * ...will be called at every change on any form field
         */
        updateShoppingcartStore() {
            this.$nextTick(() => {
                this.ShoppingCart.Customer = this.Customer;
                localStorage.shoppingcart = JSON.stringify(this.ShoppingCart);
            });
        },

        editItem(productId, id) {
            this.emitLogData('checkout', 'editItem_' + id);
            this.$router.push({
                name: 'shoppingcart',
                params: { productId: productId }
            });
        },

        /**
         * method for validating email
         * @param email
         * @returns {boolean}
         */
        validateEmail(email) {
            let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            return re.test(String(email).toLowerCase());
        },

        /**
         * method for validating shoppingcart form
         * @returns {boolean}
         */
        formValidation() {
            let formValid = true;
            let customer = this.Customer;

            if (!customer.Title) { formValid = false; }
            if (!customer.FirstName) { formValid = false; }
            if (!customer.LastName) { formValid = false; }
            if (!customer.Street) { formValid = false; }
            if (!customer.StreetNumber) { formValid = false; }
            if (!customer.ZipCode) { formValid = false; }
            if (!customer.City) { formValid = false; }
            if (!customer.Email || !this.validateEmail(customer.Email)) { formValid = false; }
            if (!customer.Phone) { formValid = false; }
            if (!this.Agb) { formValid = false; }

            return formValid;
        },

        /**
         * mehtod for getting german formatted date string
         * @return {String} current date
         */
        getCurrentDate() {
            let currentDate = new Date();
            let year = currentDate.getFullYear();
            let month = currentDate.getMonth();
            let day = currentDate.getDate();

            return year.toString() + (month + 1).toString() + day.toString();
        },

        /**
         * Returns a random integer between min (inclusive) and max (inclusive).
         * The value is no lower than min (or the next integer greater than min
         * if min isn't an integer) and no greater than max (or the next integer
         * lower than max if max isn't an integer).
         * Using Math.round() will give you a non-uniform distribution!
         */
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },

        /**
         * method for handling order logic
         */
        doOrder() {
            if (this.ShoppingCart.ProductsValid === true) {
                if (this.formValidation() === true) {
                    this.ShoppingCart.ShoppingcartId = this.getRandomInt(999999, 100000) + '-' + this.getCurrentDate();
                    this.emitLogData('checkout', 'doOrderButton_form_OK');

                    if (!this.bookingPossible) {
                        this.doOrderButtonDisabled = true;
                        let notification = $('#NotificationBetaCheckout');
                        notification.fadeIn('slow');
                        setTimeout(() => {
                            this.doOrderButtonDisabled = false;
                            setTimeout(() => {
                                notification.fadeOut();
                            }, 2500);
                        }, 500);
                    } else {
                        if (this.Customer.Phone.substr(0, 1) === '+') {
                            this.Customer.Phone = 'PLUS' + this.Customer.Phone.substr(1, this.Customer.Phone.length - 1);
                        }
                        this.ShoppingCart.Customer = this.Customer;
                        this.doOrderButtonDisabled = true;

                        axios.post(siteConfig.ajaxUrl + 'order.php', 'shoppingcart=' + encodeURIComponent(JSON.stringify(this.ShoppingCart)))
                            .then((response) => {
                                if (response.data === 'ERROR') {
                                    // show order fail notification
                                    let notification = $('#SentError');
                                    notification.html(response.data);
                                    notification.slideDown('slow');
                                    this.emitLogData('checkout', 'orderError');
                                } else {
                                    this.ShoppingCart.OrderDone = true;
                                    localStorage.setItem('shoppingcart', JSON.stringify(this.ShoppingCart));
                                    this.$emit('update-shoppingcart');
                                    this.emitLogData('checkout', 'orderDone');

                                    // push to confirmation page
                                    setTimeout(() => {
                                        this.$router.push({path: 'confirmation'});
                                    }, 1000);
                                }
                                this.sendStateActive = false;
                            })
                            .catch((textStatus) => {
                                // show order fail notification
                                let notification = $('#SentError');
                                notification.html(textStatus);
                                notification.slideDown('slow');
                                this.emitLogData('checkout', 'orderError');
                            });
                    }
                } else {
                    let notification = $('#NotificationErrorCheckout');
                    notification.fadeIn('slow');
                    this.emitLogData('checkout', 'doOrderButton_form_invalid');
                    setTimeout(function() {
                        setTimeout(function() {
                            notification.fadeOut();
                        }, 2400);
                    }, 500);
                }
            } else {
                let notification = $('#NotificationErrorShoppingcart');
                notification.fadeIn('slow');
                setTimeout(function() {
                    notification.fadeOut();
                }, 3400);
            }
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    created() {
        this.getShoppingCartContent();
    },
    mounted() {
        this.emitLogData('checkout', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('checkout', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .item {
        font-weight: bold;
    }
    .item-data {
        line-height: 1em;
        margin: -18px 0 20px 0;
    }
    .change-item {
        color: gray;
        margin-left: 10px;
        cursor: pointer;
    }
    .fas {
        margin-top: -3px;
    }
    .amount {
        font-weight: bold;
        padding-top: 15px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    .customer-data {
        padding: 15px 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    .customer-data-headline {

    }
    .form-group {
        width: 100%;
        margin-bottom: 20px !important;
    }
    .form-item-left {
        padding: 0 5px 0 0;
    }
    .form-item {
        padding: 0 5px 0 0;
    }
    .form-item-right {
        padding: 0 5px 0 0;
    }
    .form-item input,
    .form-item select,
    .form-item textarea,
    .form-item-left input,
    .form-item-left select,
    .form-item-right input,
    .form-item-right select {
        border: 1px solid lightgray;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 5px;
    }
    .form-item select {
        margin-right: 4px;
    }
    .form-label {
        color: gray;
    }
    input,
    textarea {
        width: 100%;
    }
    textarea {
        line-height: 34px;
    }
    select {
        height: 26px;
    }
    ::placeholder {
        color: lightgray;
    }
    .agb-row {
        position: relative;
        height: 80px;
    }
    .agb-input {
        position: absolute;
        top: 2px;
        left: 0;
    }
    .agb-input input {
        width: auto;
    }
    .agb-lable {
        position: absolute;
        top: 0;
        left: 30px;
    }
    .agb-lable-error {
        color: coral;
    }
    .btn-do-order {
        padding-left: 10px;
    }
    .fas {
        margin-right: 5px;
    }
    .sent-success {
        color: forestgreen;
        padding: 10px 0;
        display: none;
    }
    .sent-error {
        color: #cc0000;
        padding: 10px 0;
        display: none;
    }
    @media only screen and (max-width: 600px) {
        input,
        select,
        textarea {
            height: 36px;
        }
        .agb-row {
            height: 150px;
        }
        .agb-input {
            height: auto;
        }
        .agb-input {
            top: -5px;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .select-disabled {
        background: rgb(235, 235, 228);
    }
</style>
